// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logout-warning-overlay {
  --lw-ink: #1f1b2e;
  --lw-muted: #55515f;
  --lw-soft: #6f7588;
  --lw-lavender: #d5d1fd;
  --lw-peach: #f9e1be;
  --lw-panel: #f7f6fa;
  --lw-surface: #ffffff;
  --lw-line: rgba(31, 27, 46, 0.1);

  position: fixed;
  inset: 0;
  z-index: 1300;
  display: flex;
  align-items: safe center;
  justify-content: center;
  padding: 1.5rem;
  overflow-y: auto;
  overscroll-behavior: contain;
  background: rgba(18, 16, 26, 0.42);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
}

.logout-warning-dialog {
  width: min(100%, 440px);
  margin: auto;
  padding: 1.45rem 1.5rem 1.35rem;
  background: var(--lw-surface);
  color: var(--lw-ink);
  border: 1px solid var(--lw-line);
  border-radius: 18px;
  box-shadow: 0 22px 50px rgba(18, 16, 26, 0.22);
}

.logout-warning-dialog__eyebrow {
  margin: 0 0 0.35rem;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--lw-muted);
}

.logout-warning-dialog__title {
  margin: 0 0 0.65rem;
  font-family: "Merriweather", Georgia, serif;
  font-size: 1.35rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.25;
  color: var(--lw-ink);
}

.logout-warning-dialog__copy {
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.55;
  color: var(--lw-muted);
}

.logout-warning-dialog__actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.65rem;
  margin-top: 1.35rem;
}

.logout-warning-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 2.7rem;
  padding: 0.65rem 1rem;
  border-radius: 10px;
  font-weight: 750;
  font-size: 0.95rem;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.logout-warning-btn--ghost {
  border: 1px solid var(--lw-line);
  background: var(--lw-panel);
  color: var(--lw-ink);
}

.logout-warning-btn--ghost:hover {
  background: #ebe8f2;
}

.logout-warning-btn--leave {
  border: 1px solid rgba(232, 184, 140, 0.55);
  background: var(--lw-peach);
  color: #5a4020;
}

.logout-warning-btn--leave:hover {
  background: #f4d4a8;
}

@media (max-width: 480px) {
  .logout-warning-overlay {
    padding: 0.85rem;
  }

  .logout-warning-dialog {
    padding: 1.2rem 1.1rem 1.15rem;
  }

  .logout-warning-dialog__actions {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/LogoutWarning.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,gCAAgC;;EAEhC,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,wBAAwB;EACxB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,+BAA+B;EAC/B,6BAA6B;EAC7B,oBAAoB;EACpB,gCAAgC;EAChC,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;EAC3C,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".logout-warning-overlay {\n  --lw-ink: #1f1b2e;\n  --lw-muted: #55515f;\n  --lw-soft: #6f7588;\n  --lw-lavender: #d5d1fd;\n  --lw-peach: #f9e1be;\n  --lw-panel: #f7f6fa;\n  --lw-surface: #ffffff;\n  --lw-line: rgba(31, 27, 46, 0.1);\n\n  position: fixed;\n  inset: 0;\n  z-index: 1300;\n  display: flex;\n  align-items: safe center;\n  justify-content: center;\n  padding: 1.5rem;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  background: rgba(18, 16, 26, 0.42);\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n}\n\n.logout-warning-dialog {\n  width: min(100%, 440px);\n  margin: auto;\n  padding: 1.45rem 1.5rem 1.35rem;\n  background: var(--lw-surface);\n  color: var(--lw-ink);\n  border: 1px solid var(--lw-line);\n  border-radius: 18px;\n  box-shadow: 0 22px 50px rgba(18, 16, 26, 0.22);\n}\n\n.logout-warning-dialog__eyebrow {\n  margin: 0 0 0.35rem;\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--lw-muted);\n}\n\n.logout-warning-dialog__title {\n  margin: 0 0 0.65rem;\n  font-family: \"Merriweather\", Georgia, serif;\n  font-size: 1.35rem;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  line-height: 1.25;\n  color: var(--lw-ink);\n}\n\n.logout-warning-dialog__copy {\n  margin: 0;\n  font-size: 0.95rem;\n  line-height: 1.55;\n  color: var(--lw-muted);\n}\n\n.logout-warning-dialog__actions {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.65rem;\n  margin-top: 1.35rem;\n}\n\n.logout-warning-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 2.7rem;\n  padding: 0.65rem 1rem;\n  border-radius: 10px;\n  font-weight: 750;\n  font-size: 0.95rem;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.logout-warning-btn--ghost {\n  border: 1px solid var(--lw-line);\n  background: var(--lw-panel);\n  color: var(--lw-ink);\n}\n\n.logout-warning-btn--ghost:hover {\n  background: #ebe8f2;\n}\n\n.logout-warning-btn--leave {\n  border: 1px solid rgba(232, 184, 140, 0.55);\n  background: var(--lw-peach);\n  color: #5a4020;\n}\n\n.logout-warning-btn--leave:hover {\n  background: #f4d4a8;\n}\n\n@media (max-width: 480px) {\n  .logout-warning-overlay {\n    padding: 0.85rem;\n  }\n\n  .logout-warning-dialog {\n    padding: 1.2rem 1.1rem 1.15rem;\n  }\n\n  .logout-warning-dialog__actions {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
